class NewPasswordDirective {
  static directive() {
    return {
      scope: {
        form: '='
      },
      template: `
        <div layout="column">

        <div layout="row">
            <md-input-container flex="90" class="tooltip-container password-tooltip password-strength-container">
              <label for="password">{{ 'COMMONS.PASSWORD' | translate }}</label>
              <input id="password" name="password" ng-model="password" type="password" ng-required="true" ng-change="checkPassword(form.password, form.password2);">
              <div ng-messages="form.password.$error" multiple md-auto-hide="false" ng-show="password.$touched">
                <div ng-message="required">
                  {{ 'COMMONS.PASSWORD_REQUIRED' | translate }}
                </div>

                <div ng-message="valid">
                  {{ 'COMMONS.PASSWORD_INVALID' | translate }}
                </div>
              </div>

            </md-input-container>
          <div flex="10" layout-align="center end">
            <md-button class="md-primary" ng-click="showPasswordRequirements($event)">
              <i class="fa fa-question fa-lg" aria-hidden="true"></i>
            </md-button>
          </div>
        </div>


          <div style="visibility: hidden">
            <div class="md-dialog-container" id="passwordRequirementsDialog">
              <md-dialog layout-padding>
                <p>{{ 'COMMONS.PASSWORD_REQUIRED_TIP1' | translate }}</p>
                <p>{{ 'COMMONS.PASSWORD_REQUIRED_TIP2' | translate }}</p>
                <p>{{ 'COMMONS.PASSWORD_REQUIRED_TIP3' | translate }}</p>
                <p>{{ 'COMMONS.PASSWORD_REQUIRED_TIP4' | translate }}</p>
              </md-dialog>
            </div>
          </div>
          
        </div>
        <div layout="column">
          <md-input-container flex="100">
            <label for="password2">{{ 'COMMONS.PASSWORD_AGAIN' | translate }}</label>
            <input id="password2" name="password2" ng-model="password2" type="password" ng-required="true" ng-change="checkPassword2(form.password, form.password2)">
            <div ng-messages="form.password2.$error" multiple md-auto-hide="false" ng-show="password2.$touched">
              <div ng-message="required">
                {{ 'COMMONS.PASSWORD_AGAIN_REQUIRED' | translate }}
              </div>
  
              <div ng-message="valid">
                {{ 'COMMONS.PASSWORD_AGAIN_INVALID' | translate }}
              </div>
            </div>
          </md-input-container>
        </div>
      `,
      controller: function ($scope, PASSWORD_REGEX, $mdDialog) {
        'ngInject';


        $scope.checkPassword = function (pass1, pass2) {
          if(PASSWORD_REGEX.test(pass1.$modelValue)) {
            pass1.$setValidity('valid', true);
          } else {
            pass1.$setValidity('valid', false);
          }
          $scope.checkPassword2(pass1, pass2);
        };

        $scope.checkPassword2 = function (pass1, pass2) {
          if(pass2.$touched) {
            if (pass1.$modelValue === pass2.$modelValue) {
              pass2.$setValidity('valid', true);
            } else {
              pass2.$setValidity('valid', false);
            }
          }
        };

        $scope.showPasswordRequirements = function (ev) {
          $mdDialog.show({
            contentElement: '#passwordRequirementsDialog',
            parent: angular.element(document.body),
            targetEvent: ev,
            clickOutsideToClose: true
          });
        }
      }
    }

  };
}

export default NewPasswordDirective.directive;


// WEBPACK FOOTER //
// ./src/users/directives/new-password.js